// extracted by mini-css-extract-plugin
module.exports = {"meal":"SingleMeal_meal__3bfHm","description":"SingleMeal_description__1OaxV","price":"SingleMeal_price__2M3FR"};